import { render, staticRenderFns } from "./SpyderUpsell.vue?vue&type=template&id=cfe22b58&%23default=true"
import script from "./SpyderUpsell.vue?vue&type=script&lang=js"
export * from "./SpyderUpsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports